import React, {useState, useContext} from 'react';
import {
  Card,
  CardBoldText,
  LinkContainer,
  LinkSpace
} from 'app/src/elements';
import { Text, Pressable } from 'react-native';
import Modal from './Modal';
import EditBuyerUser from '../components/Users/BuyerUsers/edit';
import { useMutation } from '@apollo/client';
import {
  HIDE_BUYER_USER,
  REINVITE_BUYER_USER
} from '../components/Users/BuyerUsers/queries';
import AuthContext from '../contexts/AuthContext';

const BuyerUserCard = props => {
  const { hasPolicy } = useContext(AuthContext);
  const { buyerUser, setShowModal, refetch } = props;
  const [showEditBuyerUserModal, setShowEditBuyerUserModal] = useState(false);

  const [hideBuyerUser] = useMutation(HIDE_BUYER_USER, {
    onCompleted: refetch
  });

  const [reinviteBuyerUser] = useMutation(REINVITE_BUYER_USER);

  const onHide = () => {
    hideBuyerUser({ variables: {id: buyerUser.id} });
  }

  const onReinviteBuyerUser = () => {
    let message = buyerUser.invitationAcceptedAt ?
      'This will send an email with password reset instructions' :
      'This will send a new invitiation email';

    message = `${message} to ${buyerUser.email}. Continue?`;

    if (confirm(message)) {
      reinviteBuyerUser({ variables: { id: buyerUser.id } });
    }
  }

  return (
    <Card>
      <CardBoldText>
        {`${buyerUser.firstName} ${buyerUser.lastName}`}
        {'Admin' === buyerUser.role && ` - Admin`}
      </CardBoldText>
      <Text>{buyerUser.email}</Text>
      <Text>Paddle Number: {buyerUser.paddleNumber}</Text>
      {hasPolicy({ type: 'BuyerUser', action: 'update' }) && (
        <LinkContainer style={{marginTop: '20px', justifyContent: 'flex-end'}}>
          <Pressable
            onPress={() => setShowEditBuyerUserModal(true)}
            style={{alignSelf: 'flex-end'}}
          >
            <Text>
              edit
            </Text>
          </Pressable>
          <LinkSpace />
          <Pressable
            onPress={onReinviteBuyerUser}
            style={{alignSelf: 'flex-end'}}
          >
            <Text>
              {buyerUser.invitationAcceptedAt ?
                'send password reset' : 'resend invite'
              }
            </Text>
          </Pressable>
          <LinkSpace />
          <Pressable
            onPress={() => window.confirm('Hide BuyerUser?', onHide())}
            style={{alignSelf: 'flex-end'}}
          >
            <Text>
              hide
            </Text>
          </Pressable>
        </LinkContainer>
      )}
      {showEditBuyerUserModal &&
        <Modal
          buyerUser={buyerUser}
          showModal={showEditBuyerUserModal}
          setShowModal={setShowEditBuyerUserModal}
          modalType={'Edit BuyerUser'}
          objectName={`${buyerUser.firstName ? buyerUser.firstName : ''}
            ${buyerUser.lastName ? ' ' + buyerUser.lastName : ''}
          `}
        >
          <EditBuyerUser
            setShowModal={setShowEditBuyerUserModal}
            buyerUser={buyerUser}
            refetch={refetch}
          />
        </Modal>
      }
    </Card>
  )
}

export default BuyerUserCard;
